import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    Card,
    CardBody,
    DropdownToggle,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { Action } from "redux";
import { useDispatch, useSelector } from "react-redux";
import QuickForm from "Components/Common/FormBuilder/QuickForm";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { getViewList, isJson } from "utils";
import { ApplicationState } from "store";
import { viewCreateRequest, viewUpdateRequest } from "store/views/action";
import ArrangeFields from "Components/Common/FieldsArranger/ArrangeComponent";
import UpdateArrangeFields from "./UpdateArrangeFields";

const AddEntry = ({ props, show, onCloseClick, dataFields, setTriggerApi, createAction, parent, parentId, size = "", data, listActions, filter, model }: any) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const viewslist: any = useSelector((state: ApplicationState) => state.views.list?.[model]);
    const [disabled, setDisabled] = useState<any>(false)
    const [quickFields, setQuickFields] = useState<any>([])
    const [fields, setFields] = useState<any>([]);
    const [views, setViews] = useState<any>([])
    const [view, setView] = useState<any>([])
    const [viewId, setViewId] = useState<any>([])
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const OnAddEntry = (formValues: any) => {
        setDisabled(true)
        let data: any = parent ? { ...formValues, [parent]: parentId } : formValues;
        const handleSuccess = (body: any) => {
            if(filter && listActions) {
                dispatch(listActions(filter, 0, 50))
            }
            setTriggerApi((triggerApi: boolean) => !triggerApi)
            onCloseClick()
            setDisabled(false)
        }
        const handleFailure = (body: any) => {
            setDisabled(false)
        }
        dispatch(createAction(data, handleSuccess, handleFailure))
    }

    useEffect(() => { 
        let filterFields: any= []
        dataFields && dataFields.length && dataFields.map((field: any) => {
            let item = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : { ...field?.valuesJson }
            if (field?.valuesJson && item?.quickCreate) return filterFields.push(field)
        })
        setQuickFields(filterFields)
    }, [dataFields])

    useEffect(() => {
        let newViewsList = viewslist?.length ? [...viewslist] : []
        const parsedData: any = newViewsList && newViewsList?.length ? newViewsList.map((item: any) => {
            let valuesJson = item?.valuesJson || item;
            let values = { ...item, ...valuesJson }
            return values
        }) : []
        let data = parsedData && parsedData.length ? parsedData : []
        let allviews = data.filter((item: any) => (item?.location === 'quick_forms' && item?.model === model && item?.deletedAt == null))
        setViews(allviews);
        let newview = allviews?.length ? allviews?.[0] : null;
        if(newview) {
            setView(newview)
                let newFields: any = newview && newview?.fields && isJson(newview?.fields) ? JSON.parse(newview?.fields) : newview?.fields
                if (newFields?.length) {
                    setFields(newFields)
                }
                else {
                    setView(null)
                    setViewId(null)
                }
        }
        else {
            setView(null)
            setViewId(null)
        }
    }, [dispatch, model, viewslist])



    const onChange = (fields: any, viewname: any, viewId: any) => {
        if (viewId && viewId !== 'zaDefaultquickForm') {
            setFields(fields)
            let data = {
                "fields": JSON.stringify(fields),
                "name": viewname,
            }
            const handleSuccess = (body: any) => {
                getViewList(dispatch, model, "quick_forms", true)
            }
            const handleFailure = () => {

            }
            dispatch(viewUpdateRequest(viewId, data, model, handleSuccess, handleFailure))
        }
        else {
            setFields(fields)
            let data = {
                "name": 'Quick Form',
                "primary": "true",
                "model": model,
                "location": "quick_forms",
                "fields": JSON.stringify(fields),
                "filters": JSON.stringify([]),
            }
            const handleSuccess = () => {
                getViewList(dispatch, model, "quick_forms", true)
            }
            const handleFailure = () => {

            }
            dispatch(viewCreateRequest(data, model, handleSuccess, handleFailure))
        }
    }

    useEffect(() => {
        if (view && view?.id && viewId === view?.id) {
            let newview = views.find((item: any) => (viewId === item?.id))
            setViewId(newview?.id)
            setView(newview)
            let newFields: any = newview && newview?.fields && isJson(newview?.fields) ? JSON.parse(newview?.fields) : newview?.fields
            if (newFields?.length) {
                setFields(newFields)
            }
            else {
                setView(null)
                setViewId(null)
                setFields(null)
            }
        }
    }, [view])



    useEffect(() => {
        let newmetadata: any = []
        fields && fields?.length ? 
        fields.map((settingfield: any) => {
            dataFields && dataFields.map((field: any) => { 
                let item = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : {}
                if (settingfield.id == field.id && item?.quickCreate) {
                    return newmetadata.push({ ...field, extras: settingfield?.extras, hideinView: settingfield?.extras?.hideinView })
                }
            })
        })
        : dataFields && dataFields?.length && dataFields.map((field: any) => {
            let item = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : {}
            if(item?.quickCreate) {
                return newmetadata.push({ ...field, extras: { ...field?.extras, hideinView: false } })
            }
        })
        setQuickFields(newmetadata);
    }, [dataFields, fields])



    return (
        <Offcanvas
            direction="end"
            isOpen={show}
            id="offcanvasExample"
            toggle={onCloseClick}
            backdrop="static"
            className={size}
        >
            <OffcanvasHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={() => { onCloseClick(!show) }}>
                <span className="m-0 me-2 text-white d-flex gap-1 align-items-center justify-content-between">
                    {props.t("student.modals.add_new_entry")}
                    <span className="cursor-pointer">
                        <UncontrolledDropdown>
                            <DropdownToggle
                                href="#"
                                className={"btn btn-sm dropdown"}
                                tag="button"
                                title="View Settings"
                            >
                                <i className={`ri-settings-2-fill label-icon align-middle text-white fs-16 me-2`}></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem className="dropdown-item cursor-pointer" onClick={() => {setIsEditOpen(true);}} >
                                    <span className="fs-12 cursor-pointer">
                                    {props.t(`student.details.about.edit_view`)}
                                    </span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </span>
                </span>
            </OffcanvasHeader>
            <OffcanvasBody>
                <UpdateArrangeFields
                    show={isEditOpen}
                    onCloseClick={() => setIsEditOpen(false)}
                    dataFields={quickFields}
                    onChange={onChange}
                    fields={view?.fields && isJson(view.fields) ? JSON.parse(view.fields) : []}
                    views={views}
                    view={view}
                    quick={true}
                />   
                <Card className="border-0" style={{ boxShadow: 'none' }}>
                    <CardBody className="border-0">
                        <div className="live-preview vstack gap-2">
                            <QuickForm dataFields={quickFields} btnAction={OnAddEntry} btn_text={props.t("common.action_button.add_entry")} formfor="students" btndisabled={disabled} data={data} />
                        </div>
                    </CardBody>
                </Card>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default withTranslation()(AddEntry);

